//Componentes generales
import React from "react";

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox } from "@fortawesome/free-solid-svg-icons";

const RenderRow = ({ index, style, subcuentas }) => {
  const item = subcuentas[index];
  if (!item) return null; // previene nulls

  return (
    <div style={style} className="container-p-list">
      <li>
        <div className="container-p-list-item">
          <div className="container-p-list-item-horizontal">
            <div className="list-item-icon-p"><FontAwesomeIcon icon={faBox} /></div>
            <div className="label-title-products">
              Dimensión: <div className="label-subcuentas">{item.codDim} - {item.codDimDescrp}</div>
            </div>
            <div className="label-title-products">
              Código Subcuenta: <div className="label-subcuentas">{item.subCue}</div>
            </div>
            <div className="label-title-products">
              Descripción: <div className="label-subcuentas">{item.subCueDescrp}</div>
            </div>
          </div>
        </div>
      </li>
    </div>
  );
};

export default RenderRow;
